// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3naU9","colBig":"styles_colBig__3hR0R","colSmall":"styles_colSmall__1Fcze"};